class Environment {
    static get init(): IEnvironment {
        const env = (<any>window).environment || 'local';
        var settings = this.common;
        var environmentSettings = this.environments[env];
        for (const key of Object.keys(environmentSettings)) {
            settings[key] = environmentSettings[key];
        }
        return settings;
    }

    static environments: { [key: string]: IEnvironment } = {
        local: {
            appPath: '//localhost/hbms',
            mapcoreApi: 'https://pddvgisweb.penndot.pa.gov/mapcore/api/'
        },
        dev: {
            appPath: '//pddvgisweb.penndot.pa.gov/hbms',
            mapcoreApi: 'https://pddvgisweb.penndot.pa.gov/mapcore/api/'
        },
        test: {
            appPath: 'https://gistest.penndot.pa.gov/hbms',
            mapcoreApi: 'https://gistest.penndot.pa.gov/mapcore/api/'
        },
        prod: {
            appPath: '//gis.penndot.pa.gov/hbms',
            mapcoreApi: 'https://gis.penndot.pa.gov/mapcore/api/'
        }
    };

    static get common(): IEnvironment {
        return {
            appId: 6,
            pdauthAppName: 'HBMS',
            appPath: 'HBMS',
            version: '2.0.3',
            minScale: 1155582,
            billboardLayerId: 6763,
            aoiSettings: {
                assetIdConfig: [
                    {
                        columnName: 'PERMIT_NUMBER',
                        displayName: 'Permit Numbers',
                        idType: '$stringId',
                        propName: 'permitNums',
                        fieldName: 'permitNum',
                        layerId: 6763
                    },
                    {
                        columnName: 'SIGN_APPL_ID',
                        displayName: 'Application IDs',
                        idType: "$intId",
                        propName: 'billboardIds',
                        fieldName: 'billboardId',
                        layerId: 6763
                    }
                ],
                mapPickerConfig: {
                    category: 'HBMS',
                    map: 'Billboard Map (Billboards + Controlled Routes)'
                }
            },
            dataTableColumnNames: ['permit_number', 'sign_appl_id', 'district_number', 'county_code', 'route_number', 'sign_classification_code', 'sign_type_code', 'status_code', 'sign_owner_name'],
            disclaimerDoNotAcceptUrl: 'https://www.penndot.pa.gov/',
            dotNetCore: true,
            enableProdMode: true,
            extentConfigs: [
                {
                    toolTip: "Statewide",
                    icon: "m28.531 12.656-.187-.531-1.156-.344-.344-.562-.187-1.437-.719-.312-.094-.344-.375-.312h-20.219v-1.625l-1.656.844 .219-.312-.656.5-1.375.594-.406 13.906 20.719.094h1.719l.313-.531.5-.25.781 .156 1.375-.562.094-.437 1.75-1.312-1.187-1.437h-.25l-.25-.875-.531-.062-.031-.75v-.375l.406-.25.188-.469-.375-.75.844-.844.719-1.25z",
                    color: "white",
                    extent: {
                        center: [-77.6362661695295, 40.92039887644528],
                        zoom: 8
                    },
                    extentType: "static",
                    label: "Statewide Extent"
                },
                {
                    toolTip: "Current Area of Interest",
                    icon: "icon-ui-locate",
                    color: "white",
                    extentType: "async-func",
                    label: "AOI"
                }
            ]
        };
    }
}

interface IEnvironment {
    aoiSettings?: any;
    appId?: number;
    appPath?: string;
    billboardLayerId?: number;
    enableProdMode?: boolean;
    dataTableColumnNames?: string[];
    disclaimerDoNotAcceptUrl?: string;
    dotNetCore?: boolean;
    extentConfigs?: any[];
    pdauthAppName?: string;
    pdauthToken?: string;
    mapcoreApi?: string;
    minScale?: number;
    version?: string;
}

interface IAOISettings {
    assetIdConfig: any;
    mapPickerConfig: any;
}

export const environment = Environment.init;
